var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBss42BikesMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 32a26 26 0 1 0 52 0 26 26 0 1 0-52 0",
    fill: "none",
    stroke: "#9E9E9E",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8a24 24 0 0 1 11.635 44.99",
    fill: "none",
    stroke: "#FFC107",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBss42BikesMarker);
export default __webpack_public_path__ + "static/media/bss-42-bikes-marker.d3d82e647e66dc76896b41f36e7ddf16.svg";
export { ForwardRef as ReactComponent };